'use client';

import React from 'react';

import { FavouritesProvider } from '@/context/FavouritesContext';
import { UserProvider } from './UserProvider';
import { ProfileSliderProvider } from './ProfileSliderProvider';
import { NinetailedExperienceProvider } from './ninetailed/ninetailed-provider';
import { ServerAuthHintProvider } from './ServerAuthHintProvider';

export default function ClientProviders({
  children,
  mpId,
  locale,
  config,
  isLoggedInServer = false,
}: {
  children: React.ReactNode;
  mpId?: string;
  locale?: string;
  config?: any;
  isLoggedInServer?: boolean;
}) {
  return (
    <UserProvider>
      <ServerAuthHintProvider value={isLoggedInServer}>
        <ProfileSliderProvider
          node_locale={locale}
          brandId={mpId}
          config={config}
        >
          <FavouritesProvider mpId={mpId} locale={locale} config={config}>
            <NinetailedExperienceProvider>
              {children}
            </NinetailedExperienceProvider>
          </FavouritesProvider>
        </ProfileSliderProvider>
      </ServerAuthHintProvider>
    </UserProvider>
  );
}
